import {
  Box,
  Flex,
  Image,
  ListItem,
  Text,
  UnorderedList,
  Link,
  useToast,
} from '@chakra-ui/react';
import React, { useEffect, useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import styles from './footer.module.scss';
import { useDispatch, useSelector } from 'react-redux';
import {
  FaFacebook,
  FaInstagram,
  FaTiktok,
  FaYoutube,
} from 'react-icons/fa';
import { FaXTwitter } from 'react-icons/fa6';
import airtelMoney from '../../assets/img/icons/airtel-money.png';
import eziPay from '../../assets/img/icons/ezipay-logo.svg';
import mPesa from '../../assets/img/icons/mpesa.jpg';
import payPal from '../../assets/img/icons/payPal.svg';
import yasPay from '../../assets/img/icons/yasLogo.svg';
import { fetchDynamicFooter } from '../../redux/homeSlice';

let tt;

const Footer = () => {
  const dispatch = useDispatch();
  const dynamicFooter = useSelector((state) => state.home?.dynamicFooter);

  useEffect(() => {
    if (!dynamicFooter || dynamicFooter.length === 0) {
      dispatch(fetchDynamicFooter());
    }
  }, [dispatch, dynamicFooter]);

  return (
    <>
      <Box className={styles.footer} bg='#EEE' p={'40px 120px 20px 120px'}>
        <Flex
          className={styles.flex}
          justifyContent='space-between'>

          {dynamicFooter
          ?.filter((section) => section.name !== "General")
          .map((section, index) => (
            <Box key={index}>
              <Text
                fontSize={'15px'}
                borderBottom={'2px solid #303030'}
                fontWeight={600}
                lineHeight={'20px'}
                paddingBottom={'6px'}
                className={styles.title}>
                {section.name}
              </Text>
              <UnorderedList mt="10px" fontSize="13px">
                {section.subcate.map((sub, subIndex) => (
                  <Link as={RouterLink} to={`/${sub.slug}`} key={subIndex}>
                    <ListItem mb="10px">{sub.name}</ListItem>
                  </Link>
                ))}
              </UnorderedList>
            </Box>
          ))}

          {/* Pay With  */}
          <Box>
            <Text
              fontSize={'15px'}
              borderBottom={'2px solid #303030'}
              fontWeight={600}
              lineHeight={'20px'}
              paddingBottom={'6px'}
              className={styles.title}>
              Pay With
            </Text>
            <Flex mt="10px" flexDir="row" gap="20px" fontSize="40px" wrap="wrap">
              <Box width="calc(25% - 15px)">
                <Image src={yasPay} alt="mPesa" w="50px" h="35px" />
              </Box>
              <Box width="calc(25% - 15px)">
                <Image src={mPesa} alt="mPesa" w="50px" h="35px" />
              </Box>
              <Box width="calc(25% - 15px)">
                <Image src={airtelMoney} alt="Airtel Money" w="60px" h="35px" />
              </Box>
              <Box width="calc(25% - 15px)">
                <Image src={eziPay} alt="mPesa" w="50px" h="35px" />
              </Box>
              <Box width="calc(25% - 15px)">
                <Image src={payPal} alt="mPesa" w="50px" h="35px" />
              </Box>
            </Flex>
          </Box>

          {/* Contact Us  */}
          <Box>
            <Text
              fontSize={'15px'}
              borderBottom={'2px solid #303030'}
              width='80%'
              fontWeight={600}
              lineHeight={'20px'}
              paddingBottom={'6px'}
              className={styles.title}>
              Stay Connected
            </Text>

            <Flex mt='10px' flexDir='row' gap='20px' fontSize='25px'>
              <a
                href='https://www.facebook.com/kwelibuy'
                target='_blank'
                rel='noopener noreferrer'
              >
                <FaFacebook style={{ cursor: 'pointer' }} />
              </a>
              <a
                href='https://www.tiktok.com/@kwelibuy'
                target='_blank'
                rel='noopener noreferrer'
              >
                <FaTiktok style={{ cursor: 'pointer' }} />
              </a>
              <a
                href='https://www.instagram.com/kweli_buy/'
                target='_blank'
                rel='noopener noreferrer'
              >
                <FaInstagram />
              </a>
              <a
                href='https://x.com/kweliBuy'
                target='_blank'
                rel='noopener noreferrer'
              >
                <FaXTwitter style={{ cursor: 'pointer' }} />
              </a>
              <a
                href='https://www.youtube.com/@kwelibuy'
                target='_blank'
                rel='noopener noreferrer'
              >
                <FaYoutube style={{ cursor: 'pointer' }} />
              </a>
            </Flex>

            <Box mt='53px' className={styles.downloads}>
              <Text fontSize={'20px'} fontWeight={700}>
                Download App
              </Text>
              <Flex gap={'13px'} mt='28px'>
                {/* <a
                  href="#"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <Image
                    height={'32px'}
                    src={require('../../assets/img/app/appstore.png')}
                    className={styles.app}
                  />
                </a> */}
                <a
                  href="https://play.google.com/store/apps/details?id=com.kwelibuyapp"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <Image
                    height={'32px'}
                    src={require('../../assets/img/app/playstore.png')}
                    className={styles.app}
                  />
                </a>
              </Flex>
            </Box>
          </Box>
        </Flex>

        <Flex justify={'center'} borderTop={'1px solid #ED8B85'} mt='53px'>
          <Text fontSize={'15px'} pt={'15px'}>
            © 2025 All rights reserved.
          </Text>
        </Flex>
      </Box>
    </>
  );
};

export default Footer;
